import { render, staticRenderFns } from "./product.prices.vue?vue&type=template&id=022ba182&"
import script from "./product.prices.vue?vue&type=script&lang=js&"
export * from "./product.prices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports